/** @type {import('./internal').Options}  */
const options = {};

export default options;
